import type { RouteObject } from 'react-router';

import * as searchEventsHorizonRouteExports from '#/modules/search/events/page/SearchEvents.horizon-route';
import { searchEventsRoutePaths } from '#/modules/search/events/routing/searchEvents.route-paths';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const searchEventsRouteObjects = searchEventsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchEventsHorizonRouteExports),
})) satisfies RouteObject[];
